import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { FeathersService } from '../services/api/feathers.service';
import { defer, filter, iif, map, Observable, of, switchMap, take } from 'rxjs';
import { DialogService } from '../services/dialog.service';
import { AuthService } from '../services/api/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AgreementsGuard implements CanActivate {
  constructor(
    private router: Router,
    private feathers: FeathersService,
    private dialog: DialogService,
    private auth: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.feathers.initialized$.pipe(
      filter((state) => state),
      take(1),
      switchMap(() => {
        if (!this.feathers.me$.value) {
          return of(this.router.createUrlTree(['/']));
        }
        return of(!!this.feathers.me$.value?.termsAgreed).pipe(
          switchMap((isAgreed) =>
            iif(
              () => isAgreed,
              of({
                agreed: isAgreed,
                callAgreement: false,
              }),
              defer(() => this.dialog.openTermsAgreementDialog()).pipe(
                map((result) => ({
                  agreed: isAgreed,
                  callAgreement: result,
                }))
              )
            )
          ),
          switchMap((agreedState) =>
            iif(
              () => {
                return agreedState.callAgreement;
              },
              this.auth.agreeToTerms().pipe(map(() => true)),
              of(agreedState.agreed)
            )
          ),
          switchMap((result) =>
            iif(
              () => result,
              of(result),
              defer(() => this.auth.logout().pipe(map(() => false)))
            )
          ),
          map((result) =>
            result ? !!result : this.router.createUrlTree(['/'])
          )
        );
      })
    );
  }
}
